(function (send) {
    XMLHttpRequest.prototype.send = function (data) {
        var requestListenUrls = ['/cart/add.js', '/cart/update.js', '/cart/change.js', '/cart/clear.js'];
        var _this = this;
        if (_this._method === 'POST' && requestListenUrls.some(function (partialUrl) {
            return _this._url.indexOf(document.location.origin + partialUrl) === 0 ||
                _this._url.indexOf(partialUrl) === 0;
        })) {
            _this.addEventListener('readystatechange', readyStateChangeHandler);
        }
        send.call(_this, data);

        function readyStateChangeHandler(event) {
            if (_this.readyState === 4) {
                refreshCart();
                _this.removeEventListener('readystatechange', readyStateChangeHandler)
            }
        }
    };

    async function refreshCart() {
        let cartResponse  = await fetch(Shopify.routes.root+`cart.js`);
        let cart          = await cartResponse.json();
        if (!cart.token) return !!console.error("El carrito no parece correcto", cart);

      
        var _learnq = window._learnq || [];
        if (typeof klAjax !== undefined) {
            _learnq.push(['track', 'Added to Cart', cart]);
        }

        var giftCount = 0;
        var shoeCount = 0;

        // #179729 No se tienen en cuenta productos sino el total de carrito para la promoción
        if (cartIsEligibleForGift(cart)) {
            shoeCount += 1;
        }
        for( item of cart.items ) { 
            // if (itemIsShoe(item)) {
            //     shoeCount += item.quantity;
            // }
            if (itemIsGift(item)) {
                giftCount += item.quantity
            }
        }
        
        // Si es cualificable al regalo pero no tiene regalo, le añadimos el regalo
        if (giftCount <= 0 && shoeCount >= 1) {
            await addGiftToCart(cart.items);
        // Si no es cualificable y tiene regalo, se lo quitamos ya que no se lo merece
        } else if (giftCount >= 1 && shoeCount <= 0) {
            if (!await removeGiftFromCart(cart.items)) 
                throw 'Problem substracting quantity';   
        }

        let maxGiftCount = getVariantIdsToAdd(cart.items)?.length ?? 0;

        // Aquí estarán los que ya tengan el regalo (por ser cualificables) o los que no tengan regalo por no ser cualificables
        if (giftCount > maxGiftCount) {
            if (!await removeGiftFromCart(cart.items)) 
                throw 'Problem deleting all quantity';
            refreshCart();
        }
        // Aquí estarán los que ya tengan el regalo (por ser cualificables) o los que no tengan regalo por no ser cualificables

        let sampleBodyRes  = await fetch(Shopify.routes.root+'cart?view=minicart');
        let sampleBody     = await sampleBodyRes.text();
        const parser       = new DOMParser();
        const htmlDocument = parser.parseFromString(sampleBody, "text/html");
        
        let newForm = htmlDocument.querySelector(".mini-cart form");
        let oldForm = document.querySelector(".mini-cart form");
        oldForm.innerHTML = ``;
        oldForm.appendChild(newForm);
    }
    document.addEventListener('DOMContentLoaded', refreshCart);
    document.querySelector(".open-cart").addEventListener('click', refreshCart);

})(XMLHttpRequest.prototype.send);


/**
 * 
 * Obtiene el producto de regalo
 * 
 * @returns {Object} Producto de regalo
 */
let getGiftProducts = (gender) => {
    let productsData = [];
    let productData1 = retrieveJson(`gift-product-data`);
    if (productData1.error) {
        productData1 = retrieveJson(`gift-men-product-data`);
    } 
    productsData.push(productData1);
    
    let productData2 = retrieveJson(`gift-product-2-data`);
    if (productData2 && !productData2.error) {
        productsData.push(productData2);
    }

    if (gender == "hombre") {
        let genderData = retrieveJson(`gift-men-product-data`);
        if (genderData.error) {
            return false;
        }
        productsData = [genderData];
    } else if (gender == "mujer") {
        let genderData = retrieveJson(`gift-women-product-data`);
        if (genderData.error) {
            return false;
        }
        productsData = [genderData];
    }

    let thereAreVariants = false;

    productsData.forEach((_productData, _productDataIndex) => {
        if (!_productData?.variants) return;
        _productData?.variants.forEach((variant, index) => {
            thereAreVariants = true;
            let sizeData = retrieveJson(`size-equivalence-${variant.id}`);
            if (!sizeData) {
                productsData[_productDataIndex].variants[index].sizes = [variant.option2];
            } else {
                // Si tenemos equivalencias de talla añadimos todas las tallas al array
                productsData[_productDataIndex].variants[index].sizes = [];
                // El EU está hardcoded lamentablemente :(
                // Lo ideal habría sido separar las tallas en su propio metadato de tipo array pero ya es tarde para ello y hay poco tiempo
                let [sizeStart, sizeEnd] = sizeData.replace("EU", "").split("-");
                if (sizeEnd == '') {
                    sizeEnd = sizeStart;
                }
                for (let size = parseInt(sizeStart.trim()); size <= parseInt(sizeEnd.trim()); size++) {
                    productsData[_productDataIndex].variants[index].sizes.push(size);
                }
            }
        });
    });

    if (!thereAreVariants) {
        return;
    }


    return productsData;
};

/**
 * 
 * Nos informa de si un item es un zapato o no
 * 
 * @param {Object} item Item del carrito a checkear
 * 
 * @returns {Boolean} Si es un zapato o no
 * 
 */


let itemIsShoe = (item) => {
    return (item.price >= 3000);
} 

let cartIsEligibleForGift = (cart) => {
    let productThreshold  = parseInt(retrieveJson(`gift-product-price-threshold`)) * 100;
    let productExclusions = retrieveJson(`gift-product-exclusions`);
    let modelToLinkTo     = document.getElementById(`gift-model-to-link-to`)
    if (modelToLinkTo) {
        modelToLinkTo = modelToLinkTo.innerText.toLowerCase().trim();
    }
    let totalPrice        = cart.total_price
    let cartHasModelToLinkTo = false;
    if (!modelToLinkTo || modelToLinkTo === "") {
        cartHasModelToLinkTo = true;
    } else {
        let modelsToLinkTo = [modelToLinkTo];
        if (modelToLinkTo.includes(",")) {
            modelsToLinkTo = modelToLinkTo.split(",");
        }
        cart.items.forEach(item => {
            modelsToLinkTo.forEach(_modelToLinkTo => {
                let trimmedTitle = item.handle.toLowerCase().trim();
                if (!_modelToLinkTo.includes("mujer") && !_modelToLinkTo.includes("hombre")) {
                    trimmedTitle = trimmedTitle.replace("hombre", "").replace("mujer","").trim();
                }
                if (trimmedTitle === _modelToLinkTo.trim()) {
                    cartHasModelToLinkTo = true;
                }
            });
        })
    }
    
    cart.items.forEach(item => {
        let isExluded = false;
        if (productExclusions) {
            productExclusions.forEach(productExclusion => {
                if (productExclusion.id == item.product_id) {
                    isExluded = true;
                }
            })
        }

        if (isExluded) {
            totalPrice -= (item.price * item.quantity);
        }
    })
    if (!productThreshold || productThreshold <= 0) {
        productThreshold = 0;   
    }
    return totalPrice >= productThreshold & cartHasModelToLinkTo;
}

/**
 * 
 * Nos informará si un item es un regalo o no
 * 
 * @param {Object} item Item del carrito a checkear
 * 
 * @returns {Boolean} Si es un regalo o no
 * 
 */
let itemIsGift = (item) => {

    let _itemIsGift = false;
    for (giftProductKey of [`gift-product-data`, `gift-product-2-data`, `gift-men-product-data`, `gift-women-product-data` ]) {
        let giftProduct = retrieveJson(giftProductKey);
        
        if (!giftProduct.variants) {
            continue;
        }
        for (variant of giftProduct.variants) {     
            if (variant.id === item.id) {
                _itemIsGift = true;
            }
        }
    }
    return _itemIsGift;
} 


/**
 * 
 * Nos devuelve el identificador de la variante del producto que se corresponda con la talla de referencia
 * 
 * @param {Object} productData   Datos del producto 
 * @param {String} sizeToAdd Talla de referencia a añadir
 * 
 * @return {Number} El identificador de la variante que es relativo a la talla de referencia
 */
let getVariantIdsToAdd = productsData => {

    if (!productsData || !productsData.length) throw 'No product data defined!';

    // Comprobamos si el regalo se diferencia para hombre y mujer
    let genderToAdd = undefined;
    genderToAdd = productsData
        .filter( item => itemIsShoe( item ) ) // nos quedamos con solo los zapatos
        .reverse()                            // queremos coger el primer zapato
        .shift()                              // cogemos el primer elemento
        genderToAdd = genderToAdd?.handle;
    
    let giftProducts = getGiftProducts();
    if (genderToAdd) {
        if (genderToAdd.includes("hombre") && getGiftProducts("hombre")?.length) {
            giftProducts = getGiftProducts("hombre");
        } else if (getGiftProducts("mujer")?.length) {
            giftProducts = getGiftProducts("mujer");
        }
    }


    if (!giftProducts) {
        return;
    }
   
    let sizeToAdd = undefined;
    sizeToAdd = productsData
        .filter( item => itemIsShoe( item ) ) // nos quedamos con solo los zapatos
        .reverse()                            // queremos coger el primer zapato
        .shift()                              // cogemos el primer elemento
    sizeToAdd = sizeToAdd?.variant_options[1];

    let dataProductsGift = [];
    for (let productData of giftProducts) {

        if (!sizeToAdd) {
            dataProductsGift.push(getMaxSizeVariantId(productData));
            continue;
        }
    
        let colorPriority =  "";
        if (productData.handle.includes("copy-of-merino-slipper") || productData.handle.includes("regalo-merino-slipper-mujer")) {
            colorPriority = getColorPrioritySlipper();
        } else {
            colorPriority = getColorPriority();
        }
        
        // Obtenemos un array de strings <Talla>-<prioridad_de_color>-<ID>, para ordenar por orden alfabético y devolver el primero
        const sizeMatchingVariants = productData.variants
            .filter(variant => variant.available && (variant.sizes.includes( parseInt(sizeToAdd)) || variant.option2?.includes( parseInt(sizeToAdd))))
            .map(variant => `${variant.option2}-${colorPriority[variant.option1.toLowerCase()] ?? 'x'}-${variant.id}` );
    
        let dataProductGift = "";
        if (sizeMatchingVariants.length > 0) {
            // Hay variantes con la talla que corresponde: devolvemos el ID
            dataProductGift = sizeMatchingVariants.sort().shift().split('-')[2]
        } else {
            // No hay variantes, devolvemos la variante con mayor talla
            let dataProduct = getMaxSizeVariantId( productData );
    
            // Si es un Array es porque devuelve todas las variantes del regalo Slipper para poder obtener una talla más o una talla menos de la elegida, si no no se regala nada
            if (Array.isArray(dataProduct)) {
                var sizesArray = dataProduct.find(function(elemento) {
                    let sizePrevVariant = parseInt(elemento.split('-')[0]) + 1;
                    let prevVariant     = parseInt(elemento.split('-')[2]);
                    let sizePextVariant = parseInt(elemento.split('-')[0]) - 1;
                    let nextVariant     = parseInt(elemento.split('-')[2]);
                    if (sizePrevVariant == sizeToAdd) {
                        dataProductsGift.push(prevVariant);
                    } else if (sizePextVariant == sizeToAdd) {
                        dataProductsGift.push(nextVariant);
                    }
                });
                if (sizesArray) {
                    dataProductGift = sizesArray.split('-')[2];
                }
            } else {
                dataProductGift = dataProduct;
            }
        }
        dataProductsGift.push(dataProductGift);
    }
    return dataProductsGift;
};

/**
 * 
 * Obtiene la primera variante para el producto
 * 
 * @param {Object} product Datos del producto a obtener la primera varianter
 * 
 * @returns {Number} Identificador de la primera variante disponible del producto
 * 
 */
let getFirstAvailableVariantId = (product) => {
    if (!product.variants) throw 'No variants for the product data!';
    let variant_id = undefined;
    for (variant of product.variants) {
        if (!variant.available) continue;
        variant_id = variant.id;
    }
    return variant_id;
}

/**
 * Definimos las prioridades de colores:
 * Las propiedades más altas son las de número más bajo porque ordenamos por orden alfabético para determinar la variante
 * que mostraremos
 */
let getColorPriority = () => new Object({
    "navy": 0,
    "light-grey": 1,
    "navy-jaspeado": 2,
    "white": 3,
});
let getColorPrioritySlipper = () => new Object({
    "full-lightgrey": 0,
    "full-chocolate": 1,
    "full-navy": 2,
    "full-malva": 3,
});

/**
 * 
 * Obtiene la variante para el producto de mayor talla
 * @param { Object } product Datos del producto a obtener la variante con mayor talla
 * 
 * @returns { Number } Identificador de la variante con mayor talla del producto
 */
let getMaxSizeVariantId = (product) => {
    if (!product.variants) throw 'No variants for the product data!';

    let colorPriority =  "";
    if (product.handle.includes("copy-of-merino-slipper") || product.handle.includes("regalo-merino-slipper-mujer")) {
        colorPriority = getColorPrioritySlipper();
    } else {
        colorPriority = getColorPriority();
    }

    // Obtenemos un array de strings <Talla>-<prioridad_de_color>-<ID>, para ordenar por orden alfabético y devolver el primero
    const sizeAndColor = product.variants
        .filter(variant => variant.available)
        .map(variant => `${variant.option2}-${variant.option1 ? colorPriority[variant.option1.toLowerCase()] : 'x'}-${variant.id}` );

    // Ordenamos el array alfabéticamente:
    sizeAndColor.sort();

    if (product.handle.includes("copy-of-merino-slipper") || product.handle.includes("regalo-merino-slipper-mujer")) {
        // Devolvemos el ID y la talla, que será el tercer el elemento del array resultante de dividir el string por guiones:
        return sizeAndColor;
    } else {
        // Devolvemos el ID, que será el tercer el elemento del array resultante de dividir el string por guiones:
        return sizeAndColor.shift().split('-')[2];
    }
}

/**
 * 
 * Añade el regalo al carrito
 * 
 * 
 * @returns {Promise} Promesa que se resolverá cuando se complete la adición
 * 
 */
let addGiftToCart = async (cartItems) => {

    let giftVariantIds = getVariantIdsToAdd(cartItems);
    
    console.log("giftVariantIds", giftVariantIds);
    if ( !giftVariantIds || !giftVariantIds.length ) return false;
    
    let allAreOkey = true;
    for (let giftVariantId of giftVariantIds) {
        let data = new FormData();
            data.set("id", giftVariantId);
            data.set("quantity", 1);
            
        
        let response = await fetch(`/cart/add.js`, {
            method: "POST",
            body: data,
        });
        if (!(response.status === 200 && response.ok)) {
            allAreOkey = false;
        }
    }
    return allAreOkey;
}

/**
 * 
 * Quita el regalo del carrito
 * 
 * 
 * @returns {Promise} Promesa que se resuelve cuando se termina de quitar el regalo
 */
let removeGiftFromCart = async (cartItems) => {
    let allOkey = true;
    for (item of cartItems) {
        if (!itemIsGift(item)) continue;

        let data = new FormData();
            data.set("id", item.id);
            data.set("quantity", 0);
            
        let response = await fetch(`/cart/change.js`, {
            method: "POST",
            body: data,
        });
        if (!(response.status === 200 && response.ok)) {
            allOkey = false;
        }
    }    
    return allOkey;
}


/**
 *
 * Función que obtiene y procesa un JSON a partir de un elemento de script JSON
 * 
 * @param {string} elementId ID del elemento script del que sacaremos la información
 * 
 * @return {json} El JSON parseado de lo que tengamos dentro
 *
 **/
 function retrieveJson(elementId) {

	let elementJSON = document.getElementById(elementId);
	// Garantizamos que el elemento exista y tenga contenido
	if (!elementJSON || !elementJSON.innerHTML.length) 
		return false;
    // Tratamos de parsear el JSON
	let json = parseJSON(elementJSON.innerHTML);

	// Comprobamos que sea un JSON válido
	if (!json) 
		return false;

	return json;
}
/**
 *
 * Parsea un JSON controlando errores
 * 
 * @param {string} json JSON a parsear
 * 
 * @return {array/dictionary} JSON parseado a diccionario/array
 *
 **/
function parseJSON(json) {
    // Tratamos de parsearlo.
	try {
		jsonParsed = JSON.parse(json);
	} catch (e) {
        // Si falla imprimimos un error y devolvemos un array vacío
		console.warn("Encontrado JSON inválido.");
		jsonParsed = [];
	}
	return jsonParsed;
}